import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MessageCircle, X } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
export function WhatsAppFloat() {
  const {
    t
  } = useLanguage();
  const [showPopup, setShowPopup] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowPopup(true);
    }, 10000); // 10 seconds
    return () => clearTimeout(timer);
  }, []);
  return <>
      {/* Floating WhatsApp Button */}
      <motion.a href="https://wa.me/12013540888" target="_blank" rel="noopener noreferrer" className="fixed bottom-6 right-6 z-50 bg-[#25D366] text-white p-4 rounded-full shadow-2xl hover:bg-[#128C7E] transition-colors flex items-center justify-center" initial={{
      scale: 0
    }} animate={{
      scale: 1
    }} transition={{
      type: 'spring',
      stiffness: 260,
      damping: 20,
      delay: 1
    }} whileHover={{
      scale: 1.1
    }} whileTap={{
      scale: 0.9
    }} data-id="element-201">
        <MessageCircle className="w-8 h-8" data-id="element-202" />
        {/* Pulse effect */}
        <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-40 animate-ping" data-id="element-203"></span>
      </motion.a>

      {/* Popup Notification */}
      <AnimatePresence data-id="element-204">
        {showPopup && <motion.div initial={{
        opacity: 0,
        x: -50,
        y: 50
      }} animate={{
        opacity: 1,
        x: 0,
        y: 0
      }} exit={{
        opacity: 0,
        x: -50,
        y: 50
      }} className="fixed bottom-6 left-6 z-50 bg-white rounded-xl shadow-2xl border border-gray-100 p-4 max-w-xs flex items-start space-x-3" data-id="element-205">
            <div className="text-2xl pt-1" data-id="element-206">🔥</div>
            <div className="flex-1" data-id="element-207">
              <h4 className="font-bold text-brand-navy text-sm mb-1" data-id="element-208">
                {t('wa.title')}
              </h4>
              <p className="text-xs text-brand-text mb-2" data-id="element-209">{t('wa.text')}</p>
              <a href="https://wa.me/12013540888?text=Hola,%20quiero%20reservar%20mi%20cupo%20antes%20de%20que%20se%20llene%20mi%20zona" target="_blank" rel="noopener noreferrer" className="text-xs font-bold text-brand-primary hover:underline" data-id="element-210">
                {t('wa.cta')}
              </a>
            </div>
            <button onClick={() => setShowPopup(false)} className="text-gray-400 hover:text-gray-600 transition-colors" data-id="element-211">
              <X className="w-4 h-4" data-id="element-212" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </>;
}